module.exports = __webpack_public_path__ + "static/img/MA_1920_ru_awards2.68185d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MA_1920_ru_awards2.jpg
// module id = IcBd
// module chunks = 1